import { Box, Skeleton } from '@mui/material';

const RecentChatLoader = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
      }}
      data-testid="recent-chat-loader"
    >
      <Skeleton
        data-testid="recent-chat-loader-skeleton"
        variant="text"
        sx={{
          width: '100%',
          padding: { sm: '16px 20px', xs: '10px 15px' },
          marginX: '10px',
          borderRadius: '8px',
        }}
      />
    </Box>
  );
};

export default RecentChatLoader;
